import React from 'react';
import { Link } from 'react-router-dom';

import Homepage from './pages/Homepage'
import About from './pages/About'
import Mercury from './pages/Mercury';
import Venus from './pages/Venus';
import Earth from './pages/Earth';
import Mars from './pages/Mars';
import Jupiter from './pages/Jupiter';
import Saturn from './pages/Saturn';
import Navigation from './Navigation';

function PlanetList() {
	return (
<>
<h1>Planet List</h1>
<h2>Mercury</h2>
<Mercury />
<hr className="planetListHR" />
<h2>Venus</h2>
<Venus />
<hr className="planetListHR" />
<h2>Earth</h2>
<Earth />
<hr className="planetListHR" />
<h2>Mars</h2>
<Mars />
<hr className="planetListHR" />
<h2>Jupiter</h2>
<Jupiter />
<hr className="planetListHR" />
<h2>Saturn</h2>
<Saturn />
</>


		)
}

export default PlanetList;